import { Select, styled } from "@mui/material";

export const InlineSelect = styled(Select)`
  .MuiOutlinedInput-notchedOutline {
    border-style: none;
  }
` as unknown as typeof Select;
